import { get } from "../../utills/BaseService";

export async function getAllKpiMappingsByUser(dispatch: any,) {
    return await get(dispatch, '/kpiMappings/getAllKpiMappingsByUser', null)
}